/**
 * Utility to parse a date string in EST/EDT (e.g., "2025-09-15T12:00:00 EST") and return a UTC Date object.
 * Falls back to native Date parsing for ISO/UTC strings.
 */
export function parseESTToUTC(dateStr: string): Date {
  if (!dateStr) return new Date(NaN);

  // Check for EST/EDT suffix
  const estMatch = dateStr.match(/(EST|EDT)$/);
  if (estMatch) {
    // Remove the timezone suffix and parse as local to EST/EDT
    const base = dateStr.replace(/ (EST|EDT)$/, '').replace(' ', 'T');
    // EST is UTC-5, EDT is UTC-4
    const isEDT = estMatch[1] === 'EDT';
    const offset = isEDT ? -4 : -5;

    // Parse the date/time part
    const dt = new Date(base);
    if (isNaN(dt.getTime())) return new Date(dateStr); // fallback

    // Adjust to UTC by adding the EST/EDT offset
    const utc = new Date(dt.getTime() + (offset * 60 * 60 * 1000));
    return utc;
  }

  // Fallback: try native Date parsing (handles ISO/UTC)
  return new Date(dateStr);
}